import { motion } from 'motion/react';
import { 
  EnvelopeIcon
} from '@heroicons/react/24/outline';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Logo et description */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-r from-primary-500 to-accent-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">MP3</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">MP3 Random Selector</h3>
                <p className="text-gray-400 text-sm">Gestionnaire de fichiers MP3</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              MP3 Random Selector, une application concue pour choisir au hasard des fichiers MP3 dans vos dossiers, les copier et les organiser facilement. Idéal pour les mélomanes et les DJs !
            </p>
            <div className="flex space-x-4">
              <motion.a
                href="mailto:nouscontacter@mp3randomselector.fr"
                whileHover={{ scale: 1.1 }}
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors"
              >
                <EnvelopeIcon className="w-5 h-5" />
              </motion.a>
            </div>
          </div>
          
          {/* Liens rapides */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Liens rapides</h4>
            <ul className="space-y-2">
              <li>
                <a href="/#features" className="text-gray-400 hover:text-white transition-colors">
                  Fonctionnalités
                </a>
              </li>
              <li>
                <a href="/#screenshots" className="text-gray-400 hover:text-white transition-colors">
                  Captures d'écran
                </a>
              </li>
              <li>
                <a href="/#download" className="text-gray-400 hover:text-white transition-colors">
                  Télécharger
                </a>
              </li>
            </ul>
          </div>
          
          {/* Support */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Support</h4>
            <ul className="space-y-2">
              <li>
                <a href="/faq" className="text-gray-400 hover:text-white transition-colors">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Ligne de séparation */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © {currentYear} MP3 Random Selector. Tous droits réservés.
            </div>
            
            <div className="flex space-x-6 text-sm">
              <a href="/mentions-legales" className="text-gray-400 hover:text-white transition-colors">
                Mentions légales
              </a>
              <a href="/cgv" className="text-gray-400 hover:text-white transition-colors">
                CGV
              </a>
              <a href="/confidentialite" className="text-gray-400 hover:text-white transition-colors">
                Confidentialité
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
